export function initFooterAccordion() {
    const columns = document.querySelectorAll('.footer-menu__column');

    if (!columns.length) return;

    const isMobile = () => window.innerWidth < 768;

    const setHeight = (items: HTMLElement, open: boolean) => {
        if (!isMobile()) {
            items.style.height = '';
            return;
        }

        if (open) {
            items.style.height = items.scrollHeight + 'px';
        } else {
            items.style.height = '0px';
        }
    };

    columns.forEach(column => {
        const head = column.querySelector('.footer-menu__head') as HTMLElement | null;
        const items = column.querySelector('.footer-menu__items') as HTMLElement | null;

        if (!head || !items) return;

        // Стартовое состояние (если нужно — можно убрать)
        setHeight(items, column.classList.contains('active'));

        head.addEventListener('click', () => {
            if (!isMobile()) return;

            const isActive = column.classList.toggle('active');
            setHeight(items, isActive);
        });
    });

    // При ресайзе корректируем высоты
    window.addEventListener('resize', () => {
        columns.forEach(column => {
            const items = column.querySelector('.footer-menu__items') as HTMLElement | null;
            if (!items) return;

            setHeight(items, column.classList.contains('active'));
        });
    });
}
